export default Symbol('weechat')
